<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import {changeLanguage} from "@/api";

export default {
  name: 'App',
  components: {
  },
  mounted() {
    setTimeout(() => {
      //  运行时默认设置为中文模式，存本地缓存
      const lang = sessionStorage.getItem('lang')
      if (!lang) {
        sessionStorage.setItem('lang', 'zh_CN')
        changeLanguage('zh_CN').then(res => {
          // console.log(res,'app.vue调用changeLanguage')
        })
      }
      if(lang){
        // console.log(lang,'app.vue存在lang了')
        changeLanguage(lang).then(res => {
          // console.log(res,'app.vue调用changeLanguage')
        })
      }
    })
  },
//  关闭则删除缓存
  beforeDestroy() {
    sessionStorage.removeItem('lang');
  },
}
</script>

<style lang="scss">
html{
  overflow-x: hidden;
}
@font-face {
  font-family: 'Alibaba-PuHuiTi-Medium';
  src: url('./assets/Alibaba-PuHuiTi-Medium.ttf') format('truetype');
}
@font-face {
  font-family: 'Alibaba PuHuiTi';
  src: url('./assets/Alibaba-PuHuiTi-Regular.ttf') format('truetype');
}
@font-face {
  font-family: 'OPPOSans';
  src: url("./assets/OPPOSans-M.ttf") format('truetype');
}
body{
  margin: 0;
  width: 100%!important;

}
body::-webkit-scrollbar{
  width: 8px!important;
}
body::-webkit-scrollbar-track {
  background: #f1f1f1;
}
body::-webkit-scrollbar-thumb {
  background: #1C277F;
  border-radius: 3px;
}
#app {
  @media (max-width: 1600px) {
    //overflow-x: hidden!important;
    ::-webkit-scrollbar{
      //width: 0!important;
      //height: 0!important;
    }
  }
}
</style>
